import { render, staticRenderFns } from "./drawCom.vue?vue&type=template&id=610648a5&scoped=true&"
import script from "./drawCom.vue?vue&type=script&lang=ts&"
export * from "./drawCom.vue?vue&type=script&lang=ts&"
import style1 from "./drawCom.vue?vue&type=style&index=1&id=610648a5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "610648a5",
  null
  
)

export default component.exports